import React from "react";
import * as Sentry from "@sentry/react";
import styles from "./styles.module.scss";
import { history } from "../../history";
import { Button } from "../../shared/Button/Button";
import { ChevronLeftIcon } from "../../assets/Icons/ChevronLeftIcon";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("APP CRITICAL ERROR", error, errorInfo);
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.root}>
          <img src="/images/something-wrong.png" alt="error" />
          <div className={styles.message}>
            {`We're having trouble loading the page. Please try clearing your
            cache and refresh the browser. If the issue persists, please contact
            our chat support`}
          </div>
          <div className={styles.actions}>
            <Button
              size="small"
              onClick={() => history.goBack()}
              leftAdornment={<ChevronLeftIcon />}
            >
              Go Back
            </Button>
            <Button size="small" onClick={() => window.location.reload()}>
              Reload Page
            </Button>
          </div>
          <pre className={styles.error}>
            <p>{this.state.error.message}</p>
            <p>{this.state.error.stack}</p>
          </pre>
        </div>
      );
    } else {
      return this.props.children;
    }
  }
}
